import { getTypographyStyles, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300, SEM_TYPOGRAPHY_FORMS_CAPTION } from '@oneaudi/unified-web-common';
import styled, { css } from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import {} from './index.js';
import { getMargins } from '@oneaudi/unified-web-common';
export const StyledFieldset = styled.fieldset `
  margin: ${(props) => getMargins(props.margin) || 0};
  border: none;
  padding: 0;

  ${(props) => !props.hasHintOrLegend &&
    css `
      display: flex;
      flex-direction: ${props.variant === 'horizontal' ? 'row' : 'column'};
      flex-wrap: wrap;
      gap: ${SYS_SPACE_FIXED_300};
    `}
`;
export const StyledLegend = styled.legend `
  padding: 0;
  color: ${(props) => props.invalid
    ? props.theme.sem.color.forms.foreground.text.error
    : props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_CAPTION)}
  margin-bottom: ${SYS_SPACE_FIXED_150};
`;
export const StyledInner = styled.div `
  display: flex;
  flex-direction: ${(props) => props.variant === 'horizontal' ? 'row' : 'column'};
  flex-wrap: wrap;
  gap: ${SYS_SPACE_FIXED_300};
`;
export const StyledFormMessage = styled(FormMessage) `
  margin-top: ${SYS_SPACE_FIXED_150};
`;
//# sourceMappingURL=index.styles.js.map